import { Card, CardContent, Grid, Typography } from "@mui/material";
import React from "react";

import { useGetElectronicDeviceQuery } from "app/store/dashboard/electronic_device/electronicDeviceApi";
import Loading from "components/common/loading/Loading";
import DoughnutChart from "components/pages/dashboard/chart/DoughnutChart";
import { deviceTooltipHandler } from "components/pages/dashboard/cied_analytic/deviceTooltip";
import { manufacturerTooltipHandler } from "components/pages/dashboard/cied_analytic/manufacturerTooltip";
import EmptyContainer from "components/common/empty_container/EmptyContainer";
import { CLINIC_ROLES, CLINIC_NAMES } from "static/constants";
import { useSelector } from "react-redux";
import DeviceTypePatient from "components/pages/dashboard/DeviceTypePatient";
import { generateDistinctColors } from "utils/common";

const CiedAnalytic = () => {
  const { data, isLoading } = useGetElectronicDeviceQuery();
  const { currentUser } = useSelector((state) => state.auth);

  return (
    <Card
      elevation={0}
      sx={{ border: "1px solid #E0E0E0", borderRadius: "4px", height: "100%" }}
    >
      <CardContent>
        <Grid container justifyContent="center" alignItems="center">
          <Grid
            container
            item
            xs={12}
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            marginBottom={2}
          >
            <Grid item>
              <Typography
                variant="h6"
                style={{
                  fontSize: "1.125rem",
                  fontWeight: 500,
                }}
              >
                Cardiac Implantable Electronic Devices
              </Typography>
            </Grid>
            {CLINIC_ROLES.includes(currentUser?.role) &&
              currentUser?.accounts.includes(CLINIC_NAMES.UCH_SOUTH) && (
                <DeviceTypePatient currentUser={currentUser} />
              )}
          </Grid>
          {isLoading ? (
            <Loading height="320px" />
          ) : (data?.manufacturer.labels.length || data?.device.labels.length) >
            0 ? (
            <>
              {data?.manufacturer.labels.length && (
                <Grid item md={6}>
                  <DoughnutChart
                    title="Manufacturer"
                    height={210}
                    data={{
                      labels:
                        data?.manufacturer?.labels.length > 0
                          ? data?.manufacturer?.labels
                          : [],
                      datasets: [
                        {
                          data:
                            data?.manufacturer?.data.length > 0
                              ? data?.manufacturer?.data
                              : [],
                          totalDevices:
                            data?.manufacturer?.totalDevices.length > 0
                              ? data?.manufacturer?.totalDevices
                              : [],
                          backgroundColor: generateDistinctColors(
                            data?.manufacturer?.labels.length || 0
                          ),
                        },
                      ],
                    }}
                    plugins={{
                      tooltip: {
                        enabled: false,
                        position: "nearest",
                        external: manufacturerTooltipHandler,
                      },
                    }}
                  />
                </Grid>
              )}

              {data?.device.labels.length && (
                <Grid item md={6}>
                  <DoughnutChart
                    title="Device"
                    height={210}
                    data={{
                      labels:
                        data?.device?.labels.length > 0
                          ? data?.device?.labels
                          : [],
                      datasets: [
                        {
                          data:
                            data?.device?.data.length > 0
                              ? data?.device?.data
                              : [],
                          totalDevices:
                            data?.device?.totalDevices.length > 0
                              ? data?.device?.totalDevices
                              : [],
                          backgroundColor: generateDistinctColors(
                            data?.device?.labels.length || 0
                          ),
                        },
                      ],
                    }}
                    plugins={{
                      tooltip: {
                        enabled: false,
                        position: "nearest",
                        external: deviceTooltipHandler,
                      },
                    }}
                  />
                </Grid>
              )}
            </>
          ) : (
            <EmptyContainer height="300px" noDataText="No data available" />
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CiedAnalytic;
